<template>
  <div v-if="isShow">
    <div class="weui-mask_transparent"></div>
    <div class="weui-toast">
      <i v-if="icon === 'loading'" class="weui-loading weui-icon_toast"></i>
      <i
        v-if="icon === 'Success'"
        class="weui-icon-success-no-circle weui-icon_toast"
      ></i>
      <p class="weui-toast__content">{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Toast',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'None'
    },
    text: {
      type: String,
      default: '加载中'
    },
    autoHide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      errorTips: ''
    };
  },
  computed: {},
  watch: {
    isShow(value) {
      if (value && this.autoHide) {
        this.hideToast();
      }
    }
  },
  methods: {
    hideToast() {
      // 1秒后自动消失
      setTimeout(() => {
        this.$emit('update:isShow', false);
      }, 2000);
    }
  }
};
</script>

<style>
.weui-toast {
  padding: 5px 10px;
  min-width: 120px;
  max-width: 150px;
  width: auto;
}
</style>
